// extracted by mini-css-extract-plugin
module.exports = {"logo":"Supporters_logo__neA9o","supporters":"Supporters_supporters__cETZ8"};